var urlList = {
  productList: "api/v1/collection",
  rate: "api/v1/product/comment-star",
};

// 分类列表
const collectionList = new Vue({
  data: () => {
    return {
      listData: [],
      nodata: false,
      productIdList: [],
      categoryData: [],
      sectionId: "",
      page: 1,
      size: 60,
      total: 0,
      // isFreeShipping: false,
      sortList: [
        {
          label: "Comprehensive",
          value: 1,
        },
        {
          label: "Price Low to High",
          value: 4,
        },
        {
          label: "Price High to Low",
          value: 5,
        },
        {
          label: "New",
          value: 2,
        },
        {
          label: "Best Sellers",
          value: 3,
        },
      ],
      excludeField: [
        "min_price",
        "max_price",
        "pendant_material",
        "inlay_material",
        "chain_material",
        "category_rich",
        "translate",
      ],
      showSortFlag: false,
      activeIndex: 3,
      dateRanges: [
        { label: "Within last 7 day", days: 90 },
      ],
      showDateSortFlag: false,
      activeDateIndex: 0,
      minValue: 0,
      maxValue: 0,
      currencyCode: "USD",
      currencySymbol: "$",
      isLoading: true,
      loginFlag: false,
      inputValue: 1,

      currencyCode: "USD",
      currencySymbol: "$",
      minPriceInputShow: false,
      maxPriceInputShow: false,
      minPrice: 0,
      maxPrice: 0,
      maxOption: 5,
      timer: null,
      paramDate: null,
    };
  },
  created() {
    const jsonString = theme.getCookies("userSelected");
    const userSelected = theme.inspectJson(jsonString);
    this.currencyCode = userSelected?.currency_code ?? "USD";
    this.currencySymbol = decodeURIComponent(
      userSelected?.currency_symbol ?? "US$"
    );
    // const userEle = document.querySelector(".hmuser");
    // const email = userEle ? userEle.dataset.email : "";
    // !!email ? (this.loginFlag = true) : (this.loginFlag = false);
    this.loginFlag = theme.isLogin();
    const params = theme.getAllUrlParameters();
    this.paramDate = params.date;
    this.getProductList();
  },
  mounted() {
    this.similarSwiper = new Swiper(".similar-list", {
      slidesPerView: 3,
      spaceBetween: 10,
      navigation: {
        nextEl: ".similar-next",
        prevEl: ".similar-prev",
      },
      // rtl: true, // 设置为从右到左轮播
    });
  },
  watch: {
    isLoading(newValue) {
      const skeletonListEle = document.querySelector("#skeleton-collection");
      const newListEle = document.querySelector("#new-collection-list");
      if (!!newValue) {
        skeletonListEle?.classList.remove("hidden");
        newListEle?.classList.add("hidden");
      } else {
        skeletonListEle?.classList.add("hidden");
        newListEle?.classList.remove("hidden");
      }
    },
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.size);
    },
    // 是否显示左省略号
    showLeftEllipsis() {
      return this.totalPages > 7 && this.page > 4;
    },
    // 是否显示右省略号
    showRightEllipsis() {
      return this.totalPages > 7 && this.page < this.totalPages - 3;
    },
    // 中间显示的页码
    middlePages() {
      const pages = [];
      if (this.totalPages <= 7) {
        // 总页数小于等于7，显示所有页码
        for (let i = 2; i < this.totalPages; i++) {
          pages.push(i);
        }
      } else {
        let start, end;

        if (this.page <= 4) {
          // 当前页靠近开始
          start = 2;
          end = 7;
        } else if (this.page >= this.totalPages - 3) {
          // 当前页靠近结束
          start = this.totalPages - 6;
          end = this.totalPages - 1;
        } else {
          // 当前页在中间
          start = this.page - 2;
          end = this.page + 2;
        }

        for (let i = start; i <= end; i++) {
          pages.push(i);
        }
      }
      return pages;
    },
    startNumber() {
      return (this.page - 1) * this.size + 1;
    },
    endNumber() {
      let add = this.size;
      if (this.page === this.totalPages) {
        const remainder = this.total % this.size;
        add = remainder < this.size ? remainder : this.size;
      }
      return (this.page - 1) * this.size + add;
    },
  },
  methods: {
    // 返回pathName
    getPathName() {
      const url = new URL(window.location.href);
      return url.origin + url.pathname;
    },

    getNextDay(dateStr) {
      // 如果传入日期字符串，则使用传入的日期，否则使用当前日期
      const date = dateStr ? new Date(dateStr) : new Date();
      const nextDay = new Date(date);
      nextDay.setDate(nextDay.getDate() + 1);

      // 格式化日期为 YYYY-MM-DD
      let month = nextDay.getMonth() + 1;
      month = month >= 10 ? month : `0${month}`;
      let day = nextDay.getDate();
      day = day >= 10 ? day : `0${day}`;
      return `${dateStr} - ${nextDay.getFullYear()}-${month}-${day}`;
    },
    // 获取产品列表
    getProductList() {
      const range = this.dateRanges[this.activeDateIndex];
      const date = new Date();
      const nowDate = this.formatDate(date);
      options = "";
      if (range.days == 0) {
        date.setDate(date.getDate() + 1);
        options = `${nowDate} - ${this.formatDate(date)}`;
      } else {
        date.setDate(date.getDate() - range.days);
        const nextNowDate = new Date(nowDate);
        nextNowDate.setDate(nextNowDate.getDate() + 1);
        options = `${this.formatDate(date)} - ${this.formatDate(nextNowDate)}`;
      }

      const param = {
        page: this.page,
        size: this.size,
        sort: this.sortList[this.activeIndex].value,
        date_range: this.paramDate ? this.getNextDay(this.paramDate) : options,
      };

      this.isLoading = true;
      // 页面回到顶部
      this.scrollToTop();
      this.listData = [];
      fetchRequest(urlList.productList, "POST", param)
        .then((response) => {
          if (!response.error) {
            this.listData = response.data?.products;
            this.productIdList = [];
            this.listData?.forEach((item) => {
              this.productIdList.push(item.id);
              const count = this.addCartCount(item.id);
              item.cartCount = count;
              item.variant_images = item.variant_images?.map((src) => ({
                src,
                active: false,
              }));
            });
            const total = response.data?.total;
            this.total = total > 10000 ? this.calc() : total;
            this.nodata = this.total == 0 ? true : false;
            this.getProductRate();
          } else {
            this.nodata = true;
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    calc() {
      const g = Math.floor(10000 / this.size);
      return g * this.size; // total = 约数 × size
    },
    showWish(id) {
      const jsonString = localStorage.getItem("wishList");
      const userSelected = theme.inspectJson(jsonString);
      const wishList = userSelected
        ? JSON.parse(localStorage.getItem("wishList"))
        : [];
      if (wishList.includes(id)) {
        $('.wishlist[data-id="' + id + '"] .no-wish').hide();
        $('.wishlist[data-id="' + id + '"]')
          .removeClass("addto-wishlist")
          .addClass("cancel-wishlist")
          .find("span")
          .text(theme.wlAvailable);
        $('.wishlist[data-id="' + id + '"] .at')
          .removeClass("at-circle-notch-r at-spin")
          .show();
      }
    },
    // 获取产品评分
    getProductRate() {
      fetchRequest(urlList.rate, "POST", { id: this.productIdList }).then(
        (response) => {
          if (!response.error) {
            const rateData = response?.data;
            for (let item of this.listData) {
              const rate = rateData[item.id];
              this.$set(item, "rate", rate);
            }
            this.initSwipers();
          }
        }
      );
    },

    // 返回产品url
    productUrl(item) {
      return `/products/${item?.handle}`;
    },
    // 获取不同类型的id
    getIdStr(name, id) {
      return `${name}-${this.sectionId}-${id}`;
    },

    // 计算折扣
    // 计算折扣
    discount(item) {
      let percent = 0;
      if (
        item.min_compare_at_price !== item.min_price &&
        item.max_compare_at_price > 0 &&
        item.min_compare_at_price > 0
      ) {
        percent = theme.multiply(
          (item.min_compare_at_price - item.min_price) /
            item.min_compare_at_price,
          100
        );
      }
      return percent;
    },

    discountText(item) {
      const percent = this.discount(item);
      return `-${parseInt(percent)}%`;
    },
    /** 产品日期与当前日期相差七天内为true */
    newFlag(date) {
      if (!date) return false;
      const dateStr = date.split(" ")[0];
      const currentDate = new Date();
      const knownDate = new Date(dateStr);
      const timeDiff = currentDate.getTime() - knownDate.getTime();
      const dayDiff = timeDiff / (1000 * 3600 * 24);
      return Math.abs(dayDiff) <= 7;
    },
    // 添加到购物车的数量
    addCartCount(id) {
      const cartList = JSON.parse(localStorage.getItem("cartList")) || [];
      if (cartList.length == 0) return 0;
      let count = 0;
      cartList.forEach((item) => {
        if (item.product_id == id) {
          count += item.quantity;
        }
      });
      return count;
    },
    // 修改产品主图显示
    changeFeaturedImg(variant, item) {
      item.featured_image = variant.src;
      variant.active = true;
    },
    leaveImg(variant) {
      variant.active = false;
    },
    // 点击筛选freeShipping
    // clickFreeShipping() {
    //   this.isFreeShipping = !this.isFreeShipping;
    // },
    scrollToTop() {
      window.scrollTo({
        top: 0,
      });
    },
    formatPrice(item) {
      if (item.max_price == item.min_price) {
        return `${theme.formatPrice(
          theme.convertCurrency(item.max_price, "usdToSet")
        )}`;
      } else {
        return `${theme.formatPrice(
          theme.convertCurrency(item.min_price, "usdToSet")
        )} - ${theme.formatPrice(
          theme.convertCurrency(item.max_price, "usdToSet"),
          false
        )}`;
      }
    },
    initSwipers() {
      const swiperContainers = document.querySelectorAll(".swiper-container");
      swiperContainers.forEach((container) => {
        new Swiper(container, {
          direction: "vertical",
          loop: true,
          autoplay: true,
          delay: 1000,
        });
      });
      const swiperContainers2 = document.querySelectorAll(".swiper-tag");
      swiperContainers2.forEach((container) => {
        new Swiper(container, {
          direction: "vertical",
          loop: true,
          autoplay: true,
          delay: 1500,
        });
      });
    },
    prevPage() {
      if (this.page > 1) {
        this.page--;
        this.inputValue = this.page;
        this.getProductList();
      }
    },
    nextPage() {
      if (this.page < this.totalPages) {
        this.page++;
        this.inputValue = this.page;
        this.getProductList();
      }
    },
    goToPage(pageNumber) {
      let number = Number(pageNumber);
      if (number > this.totalPages) {
        number = this.totalPages;
      }
      if (number < 1) {
        number = 1;
      }
      this.inputValue = number;
      this.page = number;
      this.getProductList();
    },
    selectSort(index) {
      this.showSortFlag = false;
      this.activeIndex = index;
      document.querySelector("#selectedSort").innerHTML =
        this.sortList[this.activeIndex].label;
      this.page = 1;
      this.getProductList();
    },
    formatDate(date) {
      let month = date.getMonth() + 1;
      month = month >= 10 ? month : `0${month}`;
      let day = date.getDate();
      day = day >= 10 ? day : `0${day}`;
      return `${date.getFullYear()}-${month}-${day}`;
    },
    selectDateSort(index) {
      this.showDateSortFlag = false;
      this.activeDateIndex = index;
      document.querySelector("#selectedDateSort").innerHTML =
        this.dateRanges[this.activeDateIndex].label;
      this.page = 1;
      this.getProductList();
    },
  },
  template: `<div class="flex new-collection" id="new-collection-list">
  <div class="flex-1">
    <div class="list-top">
      <p class="title">The Latest Updates {{ paramDate }} <span class="sub-title">( Items {{ startNumber }} to {{ endNumber}} of {{ total }} Total )</span></p>
      <div class="flex gap-10">
        <div class="sort-content" @mouseenter="showSortFlag=true" @mouseleave="showSortFlag=false">
          <div class="flex align-items-center justify-space-between">
            <div>
              <span> Sort By</span>
              <span class="active margin-left-20" id="selectedSort">{{ sortList[activeIndex].label }}</span>
            </div>
            <img class="arrow arrow-dn" v-if="!showSortFlag" src="https://assets.gooddiy.com/image/arrow_dn.png">
            <img class="arrow arrow-up" v-else="showSortFlag" src="https://assets.gooddiy.com/image/arrow_up.png">
          </div>
          <div class="sort-item" v-show="showSortFlag"> 
            <div class="flex justify-space-between align-items-center" :class="activeIndex==index? 'active' : ''" v-for="(item, index) in sortList" @click="selectSort(index)">
              <span>{{ item.label }}</span>
              <img v-if="activeIndex==index" class="right" src="https://assets.gooddiy.com/image/right.png">
            </div>
          </div>
        </div>
        <div class="sort-content" @mouseenter="showDateSortFlag=true" @mouseleave="showDateSortFlag=false" v-if="!paramDate">
          <div class="flex align-items-center justify-space-between">
            <div>
              <span> Sort By</span>
              <span class="active margin-left-20" id="selectedDateSort">{{ dateRanges[activeDateIndex].label }}</span>
            </div>
            <img class="arrow arrow-dn" v-if="!showDateSortFlag" src="https://assets.gooddiy.com/image/arrow_dn.png">
            <img class="arrow arrow-up" v-else="showDateSortFlag" src="https://assets.gooddiy.com/image/arrow_up.png">
          </div>
          <div class="sort-item" v-show="showDateSortFlag"> 
            <div class="flex justify-space-between align-items-center" :class="activeDateIndex==index? 'active' : ''" v-for="(item, index) in dateRanges" @click="selectDateSort(index)">
              <span>{{ item.label }}</span>
              <img v-if="activeDateIndex==index" class="right" src="https://assets.gooddiy.com/image/right.png">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="product-content product-content-new-arrival">
      <div class="new-collection-list">
        <div class="grid grid--6-col-desktop product-list" v-if="!nodata">
          <div class="grid-item" v-for="item in listData">
            <a class=" relative" :href="productUrl(item)" target="_blank">
              <div class="basic-image">
                <img class="default-img" :src="item.featured_image + '?width=370'">
                <img class="hover-img" :src="item.featured_image2 + '?width=370'">
              </div>
              <div class="new-tag" v-if="newFlag(item.published_at)">
                <img src="https://assets.gooddiy.com/image/new_icon.png?v=20250415">
              </div>
            </a>
            <div class="relative">
              <wb-card-variant>
                <div class="wbproductdes">
                  <product-info :id="getIdStr('ProductInfo',item.id)" :data-section-input="sectionId" :data-section="sectionId" data-layout="card" :data-url="productUrl(item)">
                    <div class="card__information">
                      <div class="swiper-tag">
                        <div class="swiper-wrapper">
                          <div class="flex swiper-slide">
                            <span class="million-tag">Sign up for $1M Subsidy</span>
                          </div>

                          <div class="flex swiper-slide" v-if="item.free_shipping">
                            <span class="free-shipping-tag">free shipping</span>
                          </div>
                        </div>
                      </div>
                      <h2 class="cardhide_toggle card__heading overflow_text h5" :id="getIdStr('title',item.id)">
                        <a :href="productUrl(item)" :id="getIdStr('CardLink',item.id)" class="full-unstyled-link" target="_blank">
                          {{ item.title}}
                        </a>
                      </h2>
                      <div class="card-information">
                        <div class="wbhprice" :id="getIdStr('price',item.id)" role="status">
                          <div class="card_product_Price flex align-items-center">
                            <span class="card_sale_price notranslate">
                              {{ formatPrice(item) }}
                            </span>
                            <span class="discount-tag" v-if="discount(item)>0">{{ discountText(item) }}</span>
                          </div>
                        </div>
                        <div class="flex" v-if="loginFlag && (item.sold>0 || item.score>0)" style="max-height: 15px; overflow:hidden;">
                          <div class="swiper-container">
                            <div class="swiper-wrapper">
                              <div v-if="item.sold>0" class="product-sold swiper-slide">
                                {{ item.sold > 1000 ? (item.sold / 1000).toFixed(1) + 'K+' : item.sold }} sold recently
                              </div>
                            </div>
                          </div>
                          
                        </div>
                        <div class="flex" v-if="!loginFlag">
                          <div class="guide-login cardhide_toggle">
                            <span>Sold:</span>
                            <a href="/account/register">Login>></a>
                          </div>
                        </div>
                        
                        <div class="flex wuyuwuwwd">
                          <div class="flex wb_select_btnaa1 align-items-center">
                            <card-m-varirimg v-for="(varir, index) in item.variant_images" @mouseenter="changeFeaturedImg(varir, item)" @mouseleave="leaveImg(varir)">
                              <div class="card-m-varirimg" :class="varir.active ? 'active': ''" data-section="template--18313698181350__hot_product_HbNtUY" :data-product="item.product_id">
                                <img :src="varir.src + '?width=66'">
                              </div>
                            </card-m-varirimg>
                            <div v-if="item.variants_count>3" class="color-666">...</div>
                          </div>
                          <div class="flex align-center gap-5">
                            <div class="wb_select_btnaa1">
                              <span class="hidden">{{ showWish(item.id) }}</span>
                              <div class="btn wishlist heratPop addto-wishlist" :data-id="item.id">
                                <i class="at at-heart"></i>
                                <img class="no-wish" src="//www.gooddiy.com/cdn/shop/t/82/assets/no_wish.png" alt="">
                              </div>
                            </div>
                            <div class="wb_select_btnaa1">
                              <modal-opener data-modal="#QuickAdd" class="relative">
                                <button :id="getIdStr('quick-add',item.id)" type="submit" name="add" class="wb_select_btn1 link underlined-link quick-add__submit button--full-width" aria-haspopup="dialog"  :data-product-url="productUrl(item)" :data-product-id="item.id" data-gpo-collection-item-handle="fashion-national-flag-stainless-steel-necklace-dripping-oil-stainless-steel-necklaces-2">
                                  <span class="hidden">
                                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
                                      <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>
                                    </svg>
                                    Select options
                                  </span>
                                  <div>
                                    <img class="cart-img heratPop" src="https://cdn.shopify.com/s/files/1/0574/9807/5287/files/new-shopping-cart-af002be6.png?v=1716603513">
                                  </div>
                                  <div class="loading-overlay__spinner hidden">
                                    <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                      <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                                    </svg>
                                  </div>
                                </button>
                                <span class="add-cart-count" :class="item.cartCount>0 ? '' : 'hidden'" :data-id="item.id">{{ item.cartCount > 99 ? '99+' : item.cartCount }}</span>
                              </modal-opener>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </product-info>
                </div>
              </wb-card-variant>
            </div>
          </div>
        </div>
        <div class="pagenation justify-content-center flex" v-if="!nodata">
          <div class="pagenation-btn flex align-items-center justify-content-center border-radius-2 cursor-pointer" @click="prevPage" :disabled="page === 1">
            <img class="pagenation-arrow arrow-left" src="https://assets.gooddiy.com/image/arrow_up.png">
          </div>
          <div class="pagenation-item border-radius-2 notranslate" :class="page==1 ? 'active' : ''" @click="goToPage(1)">1</div>
          <div v-if="showLeftEllipsis" class="notranslate">...</div>
          <div class="pagenation-item border-radius-2 notranslate" :class="pageNumber==page? 'active' : ''" v-for="pageNumber in middlePages" :key="pageNumber" @click="goToPage(pageNumber)">{{ pageNumber }}</div>

          <div v-if="showRightEllipsis" class="notranslate">...</div>
          <div v-if="totalPages > 1" class="pagenation-item border-radius-2 notranslate" :class="page==totalPages ? 'active' : ''" @click="goToPage(totalPages)">{{ totalPages }}</div>
          <div class="pagenation-btn flex align-items-center justify-content-center border-radius-2 cursor-pointer" @click="nextPage" :disabled="page === totalPages">
            <img class="pagenation-arrow arrow-right" src="https://assets.gooddiy.com/image/arrow_up.png">
          </div>
        </div>
        <div class="flex justify-content-center align-items-center no-data" v-if="nodata">
          <div>
            <img src="https://assets.gooddiy.com/image/no-data.png">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>`,
});

collectionList.$mount("#new-collection-list");
